import { Routes, Route } from 'react-router-dom';
import TemplatesPage from '../pages/dashboard/components/pages/TemplatesPage';
import EmailTemplates from '../pages/email/templates/EmailTemplates';
import EmailTemplateEditor from '../pages/email/templates/EmailTemplateEditor';
import { useChannelMode } from '../context/channelModeContext';
import '../pages/email/shared/emailDesign.css';

export default function TemplatesRoute() {
  const { isEmail } = useChannelMode();

  if (isEmail) {
    return (
      <Routes>
        <Route index element={<EmailTemplates />} />
        <Route path="new" element={<EmailTemplateEditor />} />
        <Route path=":id/edit" element={<EmailTemplateEditor />} />
      </Routes>
    );
  }

  return <TemplatesPage />;
}
